import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

//MUI stuff
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import { TextField, Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

import { validateEmail } from "../../utils/utilityFunctions";
import axios from "axios";

import { updateUserCredentials } from "../../redux/actions/userActions";

const useStyles = makeStyles()((theme) => ({
  parentDiv: {
    position: "fixed",
    bottom: 20,
    right: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    overflowY: "hidden",
    overflowX: "hidden",
    backgroundColor: "#e8e8e8",
    padding: theme.spacing(1),
    borderRadius: 5,
    [theme.breakpoints.down(440)]: {
      flexDirection: "column",
    },
    maxWidth: 202,
    zIndex: 1,
  },
  text: {
    fontSize: 15,
  },
  buttonsDiv: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    paddingTop: 10,
    justifyContent: "flex-end",
    width: "100%",
  },
}));

export const RefreshAppPopUp = (props) => {
  const { classes } = useStyles();

  const handleRefresh = async () => {
    // Unregister service worker
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker.getRegistrations().then(async (registrations) => {
        for (let registration of registrations) {
          await registration.unregister();
        }
      });
    }

    // Clear cache
    const cacheNames = await caches.keys();
    await Promise.all(cacheNames.map((name) => caches.delete(name)));

    // Clear storage
    sessionStorage.clear();

    // Refresh the page and clear the cache
    window.location.reload(true);
  };

  return (
    <div>
      <div className={classes.parentDiv}>
        <Typography className={classes.text}>
          The app has been updated, please clear your cache and cookies and
          refresh your page.
        </Typography>
        {/* <div className={classes.buttonsDiv}>
          <Button onClick={handleRefresh} color="primary" variant="contained">
            Refresh
          </Button>
        </div> */}
      </div>
    </div>
  );
};

RefreshAppPopUp.propTypes = {
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = { updateUserCredentials };

export default connect(mapStateToProps, mapDispatchToProps)(RefreshAppPopUp);
